export { findElementRecursive } from '@fluentui/dom-utilities';
//# sourceMappingURL=findElementRecursive.js.map